import script from "./AppMenuBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuBar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__